'use client'

import { useGetProjectId } from '@/app/slugs'
import { GetProjectMarketCapacityReportParams } from '@/shared/api/end-points/project'
import { apiResponseHandler, queryKeys } from '@/shared/api/react-query'
import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { MarketCapacityResponse } from '../../lib'
import services from '../services'

const useGetMarketCapacityReport = (partialParams?: GetProjectMarketCapacityReportParams) => {
  const projectIdParams = useGetProjectId()
  const params = partialParams || projectIdParams

  const queryKey = [queryKeys((a, m) => a.project.getProjectMarketCapacityReport(params) + m.get)]

  const query = useQuery({
    queryKey,
    queryFn: async () => apiResponseHandler(await services.getMarketCapacityReport(params)),
    enabled: !!params.projectId,
    refetchOnWindowFocus: false,
  })

  return {
    ...query,
    queryKey,
  } as UseQueryResult<MarketCapacityResponse> & { queryKey: typeof queryKey }
}

export default useGetMarketCapacityReport
